import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { SeoCourcePageRoutingModule } from './seo-cources-routing.module';
import { SeoCourcePageListComponent } from './seo-cource-page-list/seo-cource-page-list.component';
import { SeoCourcePageCreateComponent } from './seo-cource-page-create/seo-cource-page-create.component';

@NgModule({
  declarations: [SeoCourcePageListComponent, SeoCourcePageCreateComponent],
  imports: [
    CommonModule,
    SeoCourcePageRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class SeoCourcePageModule { }
